//
// Copyright (c) 2023 Emplifi, Inc.
//

import { ButtonView, Plugin } from "ckeditor5";

interface FigureToolsAlignOption {
  icon: string;
  name: string;
  title: string;
}

export default class AlignFigureUI extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  static get pluginName() {
    return "AlignFigureUI";
  }

  init() {
    const definedAlignment = this.editor.config.get("figureTools.align.options") as
      | FigureToolsAlignOption[]
      | undefined;
    if (!Array.isArray(definedAlignment)) {
      return;
    }
    for (const styleConfig of definedAlignment) {
      this._createButton(styleConfig);
    }
  }

  private _createButton(buttonConfig: FigureToolsAlignOption) {
    const buttonName = buttonConfig.name;
    const command = this.editor.commands.get("alignFigure");
    if (command) {
      this.editor.ui.componentFactory.add(`alignFigure:${buttonName}`, (locale) => {
        const view = new ButtonView(locale);
        view.set({
          label: buttonConfig.title,
          icon: buttonConfig.icon,
          tooltip: true,
          isToggleable: true,
        });
        view.bind("isEnabled").to(command, "isEnabled");
        view.bind("isOn").to(command, "value", (value) => value === buttonName);
        view.on("execute", this._executeCommand.bind(this, buttonName));
        return view;
      });
    }
  }

  private _executeCommand(alignment: string) {
    this.editor.execute("alignFigure", alignment);
    this.editor.editing.view.focus();
  }
}
